import { createStore } from '@xstate/store';
import type { ConnectionDragState, RedockDragState, DropTarget } from '../types';
import type { AlignmentGuide } from '../lib/alignmentGuides';

export interface DragStoreContext {
  connectionDrag: ConnectionDragState | null;
  connectionDropTarget: DropTarget | null;
  redockDrag: RedockDragState | null;
  redockDropTarget: DropTarget | null;
  boxSelectRect: { x: number; y: number; width: number; height: number } | null;
  alignmentGuides: AlignmentGuide[];
}

export function createDragStore() {
  return createStore({
    context: {
      connectionDrag: null,
      connectionDropTarget: null,
      redockDrag: null,
      redockDropTarget: null,
      boxSelectRect: null,
      alignmentGuides: [],
    } as DragStoreContext,

    on: {
      'connectionDrag.set': (ctx, event: { drag: ConnectionDragState; dropTarget: DropTarget | null }) => ({
        ...ctx,
        connectionDrag: event.drag,
        connectionDropTarget: event.dropTarget,
      }),
      'connectionDrag.clear': (ctx) => ({
        ...ctx,
        connectionDrag: null as ConnectionDragState | null,
        connectionDropTarget: null as DropTarget | null,
      }),
      'connectionDropTarget.set': (ctx, event: { dropTarget: DropTarget | null }) => ({
        ...ctx,
        connectionDropTarget: event.dropTarget,
      }),
      'redockDrag.set': (ctx, event: { drag: RedockDragState; dropTarget: DropTarget | null }) => ({
        ...ctx,
        redockDrag: event.drag,
        redockDropTarget: event.dropTarget,
      }),
      'redockDrag.clear': (ctx) => ({
        ...ctx,
        redockDrag: null as RedockDragState | null,
        redockDropTarget: null as DropTarget | null,
      }),
      'redockDropTarget.set': (ctx, event: { dropTarget: DropTarget | null }) => ({
        ...ctx,
        redockDropTarget: event.dropTarget,
      }),
      'boxSelectRect.set': (ctx, event: { rect: { x: number; y: number; width: number; height: number } | null }) => ({
        ...ctx,
        boxSelectRect: event.rect,
      }),
      'alignmentGuides.set': (ctx, event: { guides: AlignmentGuide[] }) => ({
        ...ctx,
        alignmentGuides: event.guides,
      }),
    },
  });
}

export type CanvasDragStore = ReturnType<typeof createDragStore>;
